import PropTypes from 'prop-types'

import { useDirectDebitStatus } from '../../../../../contexts/session/DirectDebitContext'
import {
  MIN_AUTHORIZATION_AMOUNT_NGN,
  MAX_AUTHORIZATION_AMOUNT_NGN,
} from '../../../../../constants/DirectDebitConstants'
import { formatAuthorizationAmount } from '../../../../../utils/directDebitFormatting'
import BottomSheet from '../../../../elements/direct-debit/BottomSheet'
import Button from '../../../../elements/direct-debit/Button'

// Spec screen 05b.
const WhyFiftyNairaSheet = ({ isOpen, onClose }) => {
  const { transferDetails } = useDirectDebitStatus()
  const { displayAmount } = formatAuthorizationAmount(
    transferDetails?.metadata?.authorizationAmount,
    MIN_AUTHORIZATION_AMOUNT_NGN,
    MAX_AUTHORIZATION_AMOUNT_NGN,
  )

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      icon='sheet-question'
      title='Why do I need to make this transfer?'
      description={`The one-time ${displayAmount} transfer confirms the bank account is yours and switches the Direct Debit mandate on. It isn't a fee - it's matched back to your account automatically.`}
    >
      <Button onClick={onClose}>Got it</Button>
    </BottomSheet>
  )
}

WhyFiftyNairaSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default WhyFiftyNairaSheet
